import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner.component';
import { SpinnerService } from './spinner.service';



@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [SpinnerComponent],
  entryComponents: [SpinnerComponent],
  providers: [SpinnerService],
  exports: []
})
export class SpinnerModule { }
